import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { DeviceAsset, LineAsset, UserAsset } from '@models/dashboard.model';
import { DataLoaderDirective } from 'tangoe-design-system';

import { AssetSelectionItemComponent } from '../selection-item/asset-selection-item.component';

@Component({
  selector: 'ts-asset-card',
  templateUrl: './asset-card.component.html',
  imports: [CommonModule, DataLoaderDirective, AssetSelectionItemComponent]
})
export class AssetCardComponent {
  @Input() header: string;
  @Input() class: string = '';
  @Input() asset: UserAsset | undefined;
  @Input() additional_asset: DeviceAsset | LineAsset;
  @Input() additional_asset_type: string;
  @Input() asset_fields: string[];
  @Input() card_wrap: boolean = true;
  @Input() extras: any = null;
  @Input() is_offcanvas: boolean = false;
  @ContentChild('cardExtraContent') extra_content: TemplateRef<any> | null = null;
}
